import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    tooltipPlacement: { type: String, default: "auto" }
  }

  connect() {
    $(this.element).find('[data-toggle="tooltip"]').tooltip({
      viewport: function() {
        let overflowParentElement = this.$element.closest('.overflow-hidden, .overflow-clip, .overflow-x-hidden, .overflow-x-clip, .overflow-y-hidden, .overflow-y-clip, .ag-cell-value');
        return overflowParentElement ? overflowParentElement : 'body';
      },
      placement: $(this.element).find('[data-toggle="tooltip"]').attr('data-placement') || this.tooltipPlacementValue
    });
  }

}